import _ from "lodash"

let config = {
  apiBaseUrl: "https://api.gestaon.com.br",
  socketServer: "https://server.gestaon.com.br",
  zepplinApiBaseUrl: 'https://beta.zepplin.com.br'
}

export default config